import React, { useState } from 'react';
import { Modal, Button, Alert } from 'react-bootstrap';
import { Booking } from '../booking'; // Adjust path if needed
import ViewVehicleBookings from './ViewVehicleBookings'; // ⬅️ Adjust path if needed

interface CompletedBookingsModalProps {
  show: boolean;
  onHide: () => void;
  completedDetails: Booking[];
  completedModalError: string | null;
  statusColors: { [key: string]: string };
}

const CompletedBookingsModal: React.FC<CompletedBookingsModalProps> = ({
  show,
  onHide,
  completedDetails,
  completedModalError,
  statusColors,
}) => {
  // 🔍 for the nested view modal
  const [showViewModal, setShowViewModal] = useState(false);
  const [selectedBooking, setSelectedBooking] = useState<Booking | null>(null);

  const handleViewClick = (booking: Booking) => {
    setSelectedBooking(booking);     // pass the minimal booking; detail modal will fetch latest by id
    setShowViewModal(true);
  };

  const closeViewModal = () => {
    setShowViewModal(false);
    // keep selectedBooking if you want to reopen quickly; otherwise clear it:
    // setSelectedBooking(null);
  };

  return (
    <>
      <Modal show={show} onHide={onHide} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Completed Booking Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {completedModalError ? (
            <div className="alert alert-danger">{completedModalError}</div>
          ) : completedDetails.length > 0 ? (
            <div className="table-responsive">
              <table className="table table-striped">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Emp Num</th>
                    <th>Name</th>
                    <th>Reason</th>
                    <th>Status</th>
                    <th>Priority</th>
                    <th>Created At</th>
                    <th style={{ width: 100 }}>Actions</th> {/* ⬅️ new */}
                  </tr>
                </thead>
                <tbody>
                  {completedDetails.map((booking) => (
                    <tr key={booking.id}>
                      <td>{booking.id}</td>
                      <td>{booking.user?.empNumber || 'N/A'}</td>
                      <td>{booking.user?.name || 'N/A'}</td>
                      <td>{booking.reason || 'N/A'}</td>
                      <td>
                        <span className={statusColors[booking.status] || 'badge bg-secondary'}>
                          {booking.status || 'N/A'}
                        </span>
                      </td>
                      <td>{booking.priority || 'N/A'}</td>
                      <td>{new Date(booking.createdAt).toLocaleDateString()}</td>
                      <td>
                        <Button
                          variant="icon btn-secondary btn-sm"
                          title="View"
                          onClick={() => handleViewClick(booking)}   // ⬅️ opens detail modal
                        >
                          <i className="ti ti-eye" />
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <Alert variant="info">No completed bookings available.</Alert>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={onHide}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Nested detail modal */}
      <ViewVehicleBookings
        show={showViewModal}
        onHide={closeViewModal}
        booking={selectedBooking}
        statusColors={statusColors}
      />
    </>
  );
};

export default CompletedBookingsModal;
